






























































    import { Component, Watch, Mixins, Vue } from 'vue-property-decorator';
    import Navbar from "../components/navbar/Navbar.vue";
    import ChatComponent from '@share/chat/components/ChatComponent.vue';
    import {ParticipantStatusChange} from "../../types/ParticipantStatusChange";
    import {EventBus} from "@common/EventBus";
    import CloseBtn from "@share/common/CloseBtn.vue";
    import { InfoBlocksEnum } from "@service/types/InfoBlocksEnum";
    import AnalyticsMixin from "@mixins/AnalyticsMixin";
    import { IsMeetingsEnabled } from '@mixins/isMeetingsEnabled';
    // PartnerView import need for preventing explosion UGMK ticket list page styles
    import PartnerView from "../views/PartnerView.vue";
    import ListBlocks from "../components/list-blocks/ListBlocks.vue";
    import Onboarding from "@service/components/onboarding/Onboarding.vue";
    import Settings from "@service/components/settings/Settings.vue";
    import ChatView from "@service/views/ChatView.vue";
    import {NotificationDataHelper} from "@share/notifications/helpers/NotificationDataHelper";
    import BackgroundView from "@service/components/background-view/BackgroundView.vue";
    import { getImageUrl } from "@common/ImageUrlHelper";
    import NoticeHub from "@service/components/notice-hub/NoticeHub.vue";
    import AgoraDeviceTestModal from "@share/common/agora-device-test/AgoraDeviceTestModal.vue"
    import EventSwitcher from "../../service/components/event-switcher/EventSwitcher.vue";
    import Overlay from "@share/common/Overlay.vue";

    import PocketBlock from "../../share/common/pocket/Pocket.vue";
    import FavoritesListWrapper from "@share/favorites/FavoritesListWrapper.vue";
    import { ticketSystemIsEnabled } from '@common/serviceParamsHelper';
    import { isRouteForBackground } from "@service/router/helpers/commonRoutesHelper";
    import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
    import { ServiceName } from '@service/store/services/types';

    import AuthAnonym from "@share/auth-anonym/AuthAnonym.vue";
import { RootState } from '@service/store/types/RootState';
import { mainActions } from '@service/store/main/actions';

    @Component({
        name: 'MainLayout',
        components: {
            FavoritesListWrapper,
            NoticeHub, EventSwitcher, Overlay,
            Settings, ChatView,
            CloseBtn, Navbar, ChatComponent,
            Onboarding, AgoraDeviceTestModal,
            BackgroundView, PartnerView, PocketBlock, ListBlocks, AuthAnonym
        }
    })
    export default class MainLayout extends Mixins(AnalyticsMixin, IsMeetingsEnabled) {
        selectedUserId: number | null = null;
        eventMoreData: any = null; //here events from +n button will be stored
        showSessionList = false;
        notificationDataHelper: NotificationDataHelper | null = null;
        backgroundStoped = false;
        openedFrontBlock: InfoBlocksEnum = InfoBlocksEnum.empty;
        isShowEventSelector = false; // признак показа панели выбора мероприятий

        get isInitializing() {
            return this.$store.state.initializing;
        }

        get selectedEvent() {
            return this.$store.state.events.selected;
        }

        get selectedEventObject() {
            return this.$store.getters['events/selectedEvent'];
        }

        get eventsLoaded() {
            return this.$store.state.events.isLoaded
        }

        get showAnonymAuth() {
            return (this.$store.state as RootState).showAnonymAuth;
        }

        set showAnonymAuth(value) {
            this.$store.dispatch(mainActions.setAnonymAuthVisibility, value);
        }

        get leftPartIsOpened() {
            return false;
        }

        get defaultBackgroundUrl() {
            return require('../../assets/default_event_background.jpg');
        }

        get isNoHeaderLayout() {
            const noHeaderRoutes: string[] = [RouteNamesEnum.viewMeetingPublic];
            return noHeaderRoutes.includes(this.$route.name || '');
        }

        mounted() {
            EventBus.$on('participantStatusChanged', this.participantStatusChanged);
            EventBus.$on('modalClosed', this.modalClosed);
            EventBus.$on('program/removeMeetingById', this.removeMeetingById);
            this.$store.dispatch('invites/setRepository', this.$repositories);
            this.onSelectedEventChanged();
            document.addEventListener("visibilitychange", this.onVisibilityChange);
            if(this.notificationsIsEnabled) {
                this.notificationDataHelper = Vue.observable(new NotificationDataHelper(this.$repositories));
            }
        }

        @Watch('selectedEvent')
        onSelectedEventChanged() {
            if (this.selectedEvent && this.isMeetingsEnabled) {
                this.$store.dispatch('invites/launchFetchingCount', this.selectedEvent);
            }
        }

        toggleFrontBlock(blockType: InfoBlocksEnum) {
            //@todo check if nothing is broken, one method down as well
            this.$emit('toggleFrontBlocks', blockType);
        }

        toggleSettings() {
            this.$emit('toggleSettings')
        }

        toggleBurgerMenu() {
            this.isShowEventSelector = !this.isShowEventSelector;
        }

        /**
         * изменение открытого бокового окна
         */
        onOpenedFrontBlockChange(openedBlock: InfoBlocksEnum) {
            this.openedFrontBlock = openedBlock;
        }

        stopBackground() {
            if(!this.showBackground) {
                this.backgroundStoped = true
            }
            else {
                //остановка трансляции если перешли на роут который может показываться в фоне
                this.$store.dispatch("backgroundView/stopBroadcast", this.$store.getters["backgroundView/activeBroadcastView"]);
            }
        }

        get showBackground() {
            return isRouteForBackground(this.$route.name || '');
        }

        get showSlot() {
            return this.$route.name != 'Login';
        }

        get showFavorites() {
            return this.$route.hash == `#${InfoBlocksEnum.favorites}`;
        }

        get ticketSystemIsEnabled() {
            return ticketSystemIsEnabled();
        }

        get favoriteSessionsIsEnabled(): boolean {
            return this.$store.getters['services/serviceIsEnabled'](ServiceName.favoriteSessions, true);
        }

        get notificationsIsEnabled(): boolean {
            return this.$store.getters['services/serviceIsEnabled'](ServiceName.notifications, true);
        }

        @Watch('showBackground')
        watchShowBackground(showBackground: boolean) {
            if(showBackground) {
                this.backgroundStoped = false;
            }
        }

        get backgroundImageUrl(): string {
            const backgroundFileId = this.selectedEventObject?.backgroundFileId;

            if(backgroundFileId) {
                return getImageUrl(this.$route.params.backend, backgroundFileId, Math.min(...[window.outerWidth * 2, 1920]));
            }
            else {
                return this.defaultBackgroundUrl;
            }
        }

        participantStatusChanged(data: ParticipantStatusChange) {
            if (data.previousStatus && data.previousStatus.toLowerCase() == 'pending') {
                this.$store.dispatch('invites/decInvitesCount');
            }
        }

        onVisibilityChange() {
            if (document.hidden) {
                this.$store.dispatch('invites/stopFetching');
            }
            else {
                if (this.isMeetingsEnabled) {
                    this.$store.dispatch('invites/launchFetchingCount', this.selectedEvent);
                }
            }
        }

        modalClosed() {
            this.$clearAllBodyScrollLocks();
        }

        closePermissionsModal(event: Event) {
            event.preventDefault();
            this.$store.commit('permissionsStatus', null);
        }

        removeMeetingById(meetingId: string) {
            this.$store.dispatch('invites/removeMeeting', meetingId);
        }

        showProfile(userId: number | null) {
            this.selectedUserId = userId;
        }

        destroyed() {
            this.$store.dispatch('invites/stopFetching');
            EventBus.$off('participantStatusChanged', this.participantStatusChanged);
            document.removeEventListener("visibilitychange", this.onVisibilityChange);
            EventBus.$off('modalClosed', this.modalClosed);
            EventBus.$on('program/removeMeetingById', this.removeMeetingById);
        }
}
